import React from "react";
import { EditOutlined } from "@ant-design/icons";
import {
  Button,
  Input,
  DatePicker,
  Space,
  Tabs,
  Select,
  message,
  Tooltip,
  Popconfirm,
  Table,
  Checkbox,
} from "antd";
import { useState, useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import "../License/EditLicense.css";
import axios from "axios";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import { InputWithLabel } from "../InputWithLabel";
import TabPane from "antd/lib/tabs/TabPane";
import moment from "moment";
import Item from "antd/lib/list/Item";
dayjs.extend(weekday);
dayjs.extend(localeData);
const dateFormat = "YYYY/MM/DD";

export default function EditLicense({ isAddNew }) {


  const params = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [errors, setErrors] = useState({
    grp_error: null,
    org_error: null,
    valid_error: null,

    validity_error: null
  });
  const [activeTab, setActiveTab] = useState(searchParams.get('tab') || 'details');
  const [type, setType] = useState(searchParams.get('type') || "add")

  const [info, setInfo] = useState([]);
  const [loading, setLoading] = React.useState(false);
  const [actionPlans, setActionPlans] = React.useState([]);

  const [groups, setGroups] = useState({
    group_name: null,
    o_id: null,
    license_validity: null
  });

  const [orgName, setOrgName] = useState([]);
  const [groupName, setGrouName] = useState([]);
  const [groupId, setGrouId] = useState([]);

  const [selectedRecord, setSelectedRecord] = useState([]);


  const getDetails = async () => {
    const o_id = searchParams.get('oId')
    await axios
      .get(`/generic-api/license-group-by-group-id?group_id=${params?.group_id == "null" ? 0 : params?.group_id}&o_id=${o_id}`)
      .then((res) => {
        const data = res.data.data;
        setGroups(data)
        request(data['o_id']);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error);
          message.error(`${error.response?.status} Error ${error.response?.data?.detail}`)
        } else {
          console.log(error);
          message.error(error?.message);
        }
      });

  };


  const setDetailsKey = (key, value) => {
    if (key === 'group_name') {
      validateGroupName(value, key)
    } else {
      if (key === "o_id") {
        setErrors({ ...errors, org_error: null });
        setGroups((d) => ({
          ...d,
          [key]: value,
        }));
      } else {
        setGroups((d) => ({
          ...d,
          [key]: value,
        }));
        setErrors({ ...errors, grp_error: null });
        setErrors({ ...errors, valid_error: null });
      }
    }
  };


  useEffect(() => {
    if (type !== 'add') {
      getDetails();
    }
    if (params?.group_id === "null") {
      getGroupNames();
    }
    isAddNew = true
    getOrgNames();
  }, []);


  const getOrgNames = () => {
    axios
      .get("/generic-api/get_organisations")
      .then((res) => {
        setOrgName(res.data.data)
      })
      .catch((error) => {
        if (error.response) {
          console.log(error);
          message.error(`${error.response?.data?.detail}`)
        } else {
          console.log(error);
          message.error(error?.message);
        }
      });
  }

  const updateGroupData = () => {
    axios
      .put("/generic-api/update_license_group", groups)
      .then((res) => {
        if (res.data.data) {
          message.success(res.data.data);
        }
        navigate(`/home/groups_license`);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error);
          message.error(`${error.response?.data?.detail}`)
        } else {
          console.log(error);
          message.error(error?.message);
        }
      });
  }


  const addGroupData = () => {
    axios
      .post("/generic-api/create_license_group", groups)
      .then((res) => {
        if (res.data.data) {
          message.success(res.data.data);
        }
        navigate(`/home/groups_license`);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error);
          message.error(`${error.response?.data?.detail}`)
        } else {
          console.log(error);
          message.error(error?.message);
        }
      });
  }

  const detatchLicense = (record) => {
    axios.put(`/generic-api/license-group-detach?license_id=${record.license_id}`)
      .then((res) => {
        message.success("Detach License successfully from Group!") &&
          getDetails();
      })
      .catch((error) => {
        if (error.response) {
          console.log(error);
          message.error(`${error.response?.data?.detail}`)
        } else {
          console.log(error);
          message.error(error?.message);
        }
      });
  };

  const attachLicenselist = () => {
    axios
      .put("/generic-api/license-list-modify", {
        license: selectedRecord,
        group_id: groupId?.value
      })
      .then((res) => {
        message.success("Attach All License Successfully!")
        window.location.reload();
      })
      .catch((error) => {
        if (error.response) {
          console.log(error);
          message.error(`${error.response?.data?.detail}`)
        } else {
          console.log(error);
          message.error(error?.message);
        }
      });
  };

  function request(o_id) {
    setLoading(true);
    axios
      .get(`/generic-api/get-license-in-grp?o_id=${o_id == undefined ? searchParams.get('oId') : o_id}&group_id=${params?.group_id == "null" ? 0 : params?.group_id}`)
      .then((res) => {
        const data = res.data.data;
        setInfo(res.data.data);
        setActionPlans(data)
      })
      .catch((err) => {
        // message.error(err.message);
        message.error("Error : " + err);
        console.log(err);
      });
    setLoading(false)
  }

  const validateFields = () => {
    console.log(errors);
    setErrors((prev) => ({
      org_error: groups.o_id === null ? "Oragnisation is required !" : null,
      grp_error: groups.group_name === null || groups.group_name.length <= 0 ? 'Group name is required !' : null,
      validity_error: groups?.license_validity === null ? 'License Validity is Required !' : null
    }))
  }


  const submitGroup = () => {
    if (groups.group_name !== null && groups.o_id !== null && groups.group_name.length > 0) {
      if (type === 'add') {
        addGroupData()
      }
      else {
        if (groups?.license_validity === null) {
          validateFields()
        }
        else {
          updateGroupData()
        }
      }
    } else {
      console.log(errors);
      validateFields()
    }

  }

  const saveButton = (
    <Space>
      <Button type="primary" danger onClick={() => navigate("/home/groups_license")}>
        {" "}
        Cancel{" "}
      </Button>
      <Button type="primary" onClick={() => submitGroup()} className="bg-sky-600" htmlType="submit" disabled={params?.group_id === "null"} >
        {type === 'add' ? "Save" : "Update"}
      </Button>
    </Space>
  );

  const getGroupNames = async () => {
    if (params?.group_id === "null") {
      axios
        .get(`/generic-api/get-all-group-by-o-id?o_id=${searchParams.get('oId')}`)
        .then((res) => {
          setGrouName(res.data.data)
          // console.log(res.data.data);
        })
        .catch((err) => {
          console.log(err);
        })
    }
  }


  const handleCheckboxChange = (record, checked) => {
    if (checked && !selectedRecord.find(id => id === record?.license_id)) {
      setSelectedRecord(prev => [
        ...prev,
        record?.license_id
      ]);
    } else if (selectedRecord.find(id => id === record?.license_id)) {
      setSelectedRecord(prev => prev.filter(id => id !== record?.license_id));
    }
  };


  const Columns = [
    {
      title: "", // Empty title for the first column
      dataIndex: "checkbox",
      key: "checkbox",
      render: (text, record) => ((params.group_id === "null" && groups.group_id !== "null") ?
        <Checkbox
          // checked={checkedRows.includes(record.key)} // Assuming you have a 'checked' property in your data
          onChange={(e) => handleCheckboxChange(record, e.target.checked)}
        /> : null
      ),
    },
    {
      title: "License Name",
      dataIndex: "license_name",
      key: "license_name",
      render: (text) => <b>{text}</b>,
    },
    {
      title: "Register Name",
      dataIndex: "register_user_name",
      key: "register_user_name",
      render: (text, record) => (
        <a onClick={() => navigate(`/home/registers/view/${record.reg_id}`, {})}>{text} </a>
      ),
    },
    {
      title: "Oragnisation Name",
      dataIndex: "o_name",
      key: "o_name",
    },
    {
      title: "Application Name",
      dataIndex: "application_name",
      key: "application_name",
    },
    {
      title: "License Token",
      dataIndex: "license_token",
      key: "license_token",
    },
    {
      title: "License Key",
      dataIndex: "license_key",
      render: (text, record) => {
        return (
          <>
            <Button
              type="dashed"
              onClick={() => {
                if (navigator.clipboard && window.isSecureContext) {
                  navigator.clipboard.writeText(record.license_key);
                  message.info(`License Key Copied : ${record.license_key}`);
                } else {
                  let textArea = document.createElement("textarea");
                  textArea.value = record.license_key;
                  textArea.style.position = "fixed";
                  textArea.style.left = "-999999px";
                  textArea.style.top = "-999999px";
                  document.body.appendChild(textArea);
                  textArea.focus();
                  textArea.select();
                  message.info(`License Key Copied : ${record.license_key}`);
                  return new Promise((res, rej) => {
                    document.execCommand("copy") ? res() : rej();
                    textArea.remove();
                  });
                }
              }}
            >
              View & Copy
            </Button>
          </>
        );
      },
    },
    {
      title: "License Validity",
      dataIndex: "license_validity",
      render: (text, record) => {
        let date = moment(record.license_validity);
        let now = moment();
        let diff = date.diff(now, "days");
        if (diff > -1) {
          return (
            <>
              <Tooltip title={moment(record.license_validity).format("DD-MM-YYYY HH:mm:ss")}>
                <span style={{ color: "green" }}>
                  {diff} days left to expire
                </span>
              </Tooltip>
            </>
          );
        } else {
          return (
            <>
              <Tooltip title={moment(record.license_validity).format("DD-MM-YYYY HH:mm:ss")}>
                <span style={{ color: "red" }}>Expired</span>
              </Tooltip>
            </>
          );
        }
      },
      sorter: (a, b) => moment(a.license_validity).diff(moment(b.license_validity)),

    },
    {
      title: "Operation",
      dataIndex: "operation",
      hidden: (params.group_id === "null"),
      render: (_, record) =>
        (info.length >= 1) ? (
          <Space>
            <Popconfirm
              title={`Are you sure you want to ${params.group_id === "null" ? "attach" : "detach"} the license to the group?`}
              onConfirm={() =>
                params.group_id === "null"
                  ? null
                  : detatchLicense(record)
              }
            >
              <Button style={{ background: params.group_id === "null" ? "lightyellow" : "orange", borderColor: params.group_id === "null" ? "green" : "orange" }}>
                {params.group_id === "null" ? "Attach Group" : "Detach Group"}
              </Button>
            </Popconfirm>
          </Space>
        ) : null
      ,
    },
  ].filter((item) => {
    if (item.hidden) {
      return false
    }
    return true
  });

  const changeActiveTab = (key) => {
    setActiveTab(key);
    searchParams.set('tab', key);
    setSearchParams(searchParams, { replace: true });
  }

  const checkAttachCondition = () => {
    if (selectedRecord.length === 0 || groupId?.value === null || groupId?.value === undefined) {
      return true;
    } else {
      return false;
    }
  }
  const validateGroupName = (value, key) => {

    const regex = /^[a-zA-Z0-9]*$/; // Regex to allow only alphanumeric characters
    if (!regex.test(value)) {
      setErrors({ ...errors, grp_error: 'Special characters or spaces not allowed!' });
      // setErrors({ ...errors, grp_error: null });
    } else {
      setGroups((d) => ({
        ...d,
        [key]: value,
      }));
      setErrors({ ...errors, grp_error: null });
    }
  };

  return (
    <div className="my-form-outer">
      <Tabs activeKey={activeTab} tabBarExtraContent={saveButton} className="buttonlicense" onChange={changeActiveTab}>
        <TabPane className="my-form-tabpane-outer" tab="Group Details" key="details">

          <div className="flex gap-4">
            <div className="my-form-multiple-inline-input">
              {params?.group_id !== "null" ?
                <InputWithLabel label="Group Name" reqMark={true} error={errors.license_name}>
                  <Input
                    status={errors.grp_error !== null && 'error'}
                    value={groups?.group_name}
                    className="my-form-input"
                    onChange={(e) => setDetailsKey("group_name", e.target.value)}
                  />
                  {errors.grp_error !== null && <h1 className="text-red-500">{errors.grp_error}</h1>}
                </InputWithLabel> : <InputWithLabel label="Group Name" error={errors.license_name}>
                  <Input
                    disabled="true"
                    status={errors.grp_error !== null && 'error'}
                    value={groups?.group_name}
                    className="my-form-input"
                  />
                  {errors.grp_error !== null && <h1 className="text-red-500">{errors.grp_error}</h1>}
                </InputWithLabel>
              }
            </div>

            <div className="my-form-multiple-inline-input">
              {params?.group_id !== "null" ?
                <InputWithLabel label="Organization Name" reqMark={true} error={errors.o_id}>
                  <Select
                    showSearch
                    status={errors.org_error !== null && 'error'}
                    className="my-form-input"
                    value={groups?.o_id || "Select Organization"}
                    onChange={(value) => setDetailsKey("o_id", value)}
                    options={orgName?.map((items) => ({
                      value: items.o_id,
                      label: items.o_name,
                    }))}
                    allowClear
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                  {errors.org_error !== null && <h1 className="text-red-500">Orgnization is required!</h1>}
                </InputWithLabel> : <InputWithLabel label="Organization Name" error={errors.o_id}>
                  <Select
                    disabled="true"
                    status={errors.org_error !== null && 'error'}
                    className="my-form-input"
                    value={groups?.o_name || "Select Organization"}
                  />
                  {errors.org_error !== null && <h1 className="text-red-500">Orgnization is required!</h1>}
                </InputWithLabel>
              }
            </div>

            <div className="my-form-multiple-inline-input">

              {
                type === "edit" && params?.group_id !== "null" &&
                <InputWithLabel label="License Validity" reqMark={true} error={errors.license_validity}>

                  <DatePicker
                    status={errors?.license_validity?.errors[0]?.msg && 'error'}
                    allowClear={false}
                    value={groups?.license_validity ? dayjs(groups?.license_validity, dateFormat) : null}
                    onChange={(date, dateString) => {
                      setDetailsKey("license_validity", date);
                    }}
                    className="my-form-input"
                    format={dateFormat}
                  />
                  {errors.validity_error !== null && <h1 className="text-red-500">License Validity is required!</h1>}
                </InputWithLabel>
              }

            </div>

          </div>

          <div className="my-form-multiple-inline-input">

            {params?.group_id === "null" &&

              <InputWithLabel label="Group Name" reqMark={true} error={errors.o_id}>

                <Select
                  status={errors?.o_name?.errors[0]?.msg && 'error'}
                  className="my-form-input"
                  value={groupId['label'] || "Select Group"}
                  onChange={(value, label) => setGrouId(label)}
                  options={groupName?.map((items) => ({
                    value: items.group_id,
                    label: items.group_name,
                  }))}
                />

              </InputWithLabel>
            }

            {params?.group_id === "null" &&
              <Popconfirm title={`Are you sure you want to ${params.group_id === "null" ? "attach" : "detach"} the license to the group?`}
                disabled={checkAttachCondition()}
                onConfirm={() =>
                  params.group_id === "null" ? attachLicenselist() : null
                }
              >
                <Button
                  disabled={checkAttachCondition()}
                  className="mt-5"
                  danger
                >Attach checked License
                </Button>
              </Popconfirm>}
          </div>

          <div>
            {type === "edit" &&
              <Table
                style={{ marginTop: 30 }}
                columns={Columns}
                loading={loading}
                dataSource={actionPlans}
                size="small"
                pagination={{ position: ["bottomRight"], showSizeChanger: true, }}
              />}
          </div>
        </TabPane>

      </Tabs>

    </div>
  );
}
